import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'
import {getFilterFromAction} from 'helpers/reducer'

export const contactsContextOpportunitiesTabPivotTableKey = 'contactsContext.selected.opportunitiesTab.pivotTable'

const showClosed = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_OPPORTUNITIES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showClosed')
    default:
      return state
  }
}

export const showAllContacts = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_OPPORTUNITIES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showAllContacts')
    default:
      return state
  }
}

export default combineReducers({
  showClosed,
  showAllContacts,
  pivotTable: createPivotTableReducer({key: contactsContextOpportunitiesTabPivotTableKey, defaultSortColumn: 'expectedDate',defaultSortDirection: 'desc'}),
})
